import React from 'react'
import { cn } from '../../lib/cn'

/**
 * Estado vacío elegante y reutilizable.
 * @param {{ icon?: React.ReactNode, title: string, description?: string, action?: React.ReactNode }} props
 */
export function EmptyState({ icon, title, description, action, className, ...rest }) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-2xl border border-dashed border-hairline bg-surface px-6 py-14 text-center',
        className
      )}
      {...rest}
    >
      {icon && (
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-slate-100 text-ink-muted">
          {icon}
        </div>
      )}
      <h3 className="text-lg font-semibold text-ink">{title}</h3>
      {description && (
        <p className="mx-auto mt-1.5 max-w-sm text-sm text-ink-soft">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}

export default EmptyState
